"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.default = (function (virtual) { return function (data) {
    var fields = virtual.protocol.fields;
    var cmds = virtual.protocol.cmds;
    var raw = data.raw || '';
    var cmdId = utils_1.hexToDec(raw.slice(8, 10));
    raw = raw.slice(10, -2);
    var cmd = cmds[cmdId];
    if (!cmd) {
        return data;
    }
    return cmd.fields.reduce(function (val, field) {
        var _a = fields[field], dataLength = _a.dataLength, dataType = _a.dataType;
        if (dataType === 'NUMBER') {
            val[field] = utils_1.hexToDec(raw.slice(0, dataLength * 2));
        }
        else if (dataType === 'STRING') {
            var codes = utils_1.splitByLength(raw.slice(0, dataLength * 2))
                .map(function (val) { return utils_1.hexToDec(val); })
                .filter(function (val) { return val; });
            val[field] = utils_1.UTF8BytesToRaw(codes);
        }
        raw = raw.slice(dataLength * 2);
        return val;
    }, { cmdId: cmdId });
}; });



// WEBPACK FOOTER //
// ./src/decode/jsonTransparent.ts